webpackJsonp([250945696650520],{

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Connect = __webpack_require__(29);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Connect2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Extending or Overriding Blueprints'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section explains how to create your own blueprints.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Blueprint Structure'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'All blueprints are a template that describe how to convert the arguments in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getState'
	      ),
	      ' method call to a reducer lookup and an action call.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You have no control over the template itself (without creating a custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-connect'
	      ),
	      ' hook), but you have complete control over the steps ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'within'
	      ),
	      ' each the template.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is the structure of a template.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      export default {\n\n        defaults: {\n          // default arguments you want provided to all getState calls for this blueprint\n        },\n\n        verifyParams: function(params) {\n          // determines whether the parameters passed to the getState call are valid\n        },\n\n        getReducerState: function(storeState) {\n          // gets the subset of the store state we are interested in\n        },\n\n        getPayload: function(reducerState, params) {\n          // gets the piece of data in the subset of the store state we want\n        },\n\n        callAction: function(action, params) {\n          // controls how the action gets called\n        }\n\n      }\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To illustrate the interface, let\'s take a look at how you could add the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'all'
	      ),
	      ' blueprint yourself.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'First, you need to define the blueprint in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'config/connect.js'
	      ),
	      ' file like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // config/connect.js\n      import _ from \'lodash\';\n\n      export default {\n\n        blueprints: {\n          all: {\n            defaults: {\n              where: function(model) {\n                return true;\n              },\n              sortBy: function(model) {\n                return true;\n              }\n            },\n\n            verifyParams: function(params) {\n              if (!_.isFunction(params.where)) {\n                throw new Error("The \'where\' field must be a function");\n              }\n\n              if (!_.isFunction(params.sortBy)) {\n                throw new Error("The \'sortBy\' field must be a function");\n              }\n            },\n\n            getAction: function(actions) {\n              // no op\n            },\n\n            getPayload: function(reducerState, params) {\n              var data = _\n                .chain(reducerState)\n                .transform(function(result, model) {\n                  result.push(model);\n                }, [])\n                .filter(params.where)\n                .sortBy(params.sortBy)\n                .value();\n\n              return {\n                state: \'RESOLVED\',\n                data: data\n              };\n            }\n          }\n        }\n      };\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint defines two default parameters, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'where'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'sortBy'
	      ),
	      ', has no action, and iterates through the provided ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'reducerState'
	      ),
	      ', filtering and sorting the results, which are then returned in a data structure with the state always set to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'RESOLVED'
	      ),
	      ' (since it makes no server calls, the state is never transient).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next, you need to tell lore how to use it. To do that, we need to define a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'reducerActionMap'
	      ),
	      ', and we can use the new ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '*'
	      ),
	      ' syntax to say "this mapping applies to all models".'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // config/connect.js\n      export default {\n        blueprints: {\n          all: {\n            // ... definition\n          }\n        },\n\n        reducerActionMap: {\n          \'*.all\': {\n            action: null,\n            reducer: \'*.byCid\',\n            blueprint: \'filter\'\n          }\n        }\n\n      };\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'That\'s it! With those two changes, you can easily extend and override the behavior of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'connect'
	      ),
	      ' function and associated ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'getState'
	      ),
	      ' calls.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-connect-extending-js-febcb3db8a873ff1d248.js